import { render, staticRenderFns } from "./UserGroup.vue?vue&type=template&id=6fb08b2e&scoped=true"
import script from "./UserGroup.vue?vue&type=script&lang=js"
export * from "./UserGroup.vue?vue&type=script&lang=js"
import style0 from "./UserGroup.vue?vue&type=style&index=0&id=6fb08b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb08b2e",
  null
  
)

export default component.exports